if (!customElements.get('back-in-stock')) {
  customElements.define(
    'back-in-stock',
    class BackInStock extends HTMLElement {
      constructor() {
        super();

        this.onSubmitHandler = this.onSubmitHandler.bind(this);
      }

      connectedCallback() {
        this.form = this.querySelector('form');
        this.notify = this.querySelector('.notify');

        if (!this.form) return;

        this.action = this.form.action;
        this.form.addEventListener('submit', this.onSubmitHandler);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.onSubmitHandler);
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        const email = this.querySelector('[name="email"]')?.value;
        const variantId = this.querySelector('[name="variant"]')?.value;

        if (!email || !variantId) return;

        try {
          const response = await fetch(this.action, {
            method: 'POST',
            headers: {
              accept: 'application/json',
              revision: '2024-06-15',
              'content-type': 'application/json',
            },
            body: JSON.stringify({
              data: {
                type: 'back-in-stock-subscription',
                attributes: {
                  channels: ['EMAIL'],
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email,
                      },
                    },
                  },
                },
                relationships: {
                  variant: {
                    data: {
                      type: 'catalog-variant',
                      id: `$shopify:::$default:::${variantId}`,
                    },
                  },
                },
              },
            }),
          });

          if (response.status === 202) {
            this.form.closest('.notify__form')?.classList.add('hidden');
            this.notify?.classList.add('notify--success');
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
  );
}
